// extracted by css-extract-rspack-plugin
export default {"root":"root-gIDAp2","top":"top-uAx1Zc"};